import { render, staticRenderFns } from "./siview-consults.vue?vue&type=template&id=6cc629ea&scoped=true&"
import script from "./siview-consults.vue?vue&type=script&lang=js&"
export * from "./siview-consults.vue?vue&type=script&lang=js&"
import style0 from "./siview-consults.vue?vue&type=style&index=0&id=6cc629ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc629ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
